const SENSITIVE = /token|secret|password|key|credential|auth/i;
const REDACTED = "[REDACTED]";

const JSON_KV = new RegExp(
  `(\\\\*"[^"]*(?:${SENSITIVE.source})[^"]*\\\\*"\\s*:\\s*\\\\*")((?:[^"\\\\]|\\\\.)*)(\\\\*")`,
  "gi"
);

const XML_EL = new RegExp(
  `(<[\\w-]*(?:${SENSITIVE.source})[\\w-]*>)([^<]+)(</[\\w-]*(?:${SENSITIVE.source})[\\w-]*>)`,
  "gi"
);

const redactInString = (s) => s.replace(JSON_KV, `$1${REDACTED}$3`);

export const sanitizeXml = (s) => s?.replace(XML_EL, `$1${REDACTED}$3`) ?? s;

export const sanitizeSecrets = (data) => {
  if (data == null) return data;

  if (typeof data === "string") {
    const t = data.trim();
    if (
      (t[0] === "{" && t.endsWith("}")) ||
      (t[0] === "[" && t.endsWith("]"))
    ) {
      try {
        const p = JSON.parse(data);
        const s = sanitizeSecrets(p);
        return typeof p === "string"
          ? sanitizeSecrets(s)
          : redactInString(JSON.stringify(s));
      } catch {}
    }
    return redactInString(data);
  }

  if (Array.isArray(data)) {
    const r = [];
    let next = false;
    for (const item of data) {
      if (next && typeof item === "string") {
        r.push(REDACTED);
        next = false;
      } else if (typeof item === "string" && SENSITIVE.test(item)) {
        r.push(item);
        next = true;
      } else {
        r.push(sanitizeSecrets(item));
        next = false;
      }
    }
    return r;
  }

  if (typeof data === "object") {
    return Object.fromEntries(
      Object.entries(data).map(([k, v]) => [
        k,
        typeof v === "string" && SENSITIVE.test(k)
          ? REDACTED
          : sanitizeSecrets(v),
      ])
    );
  }

  return data;
};
